<template>
  <div>
    <!-- Лоадер первичной загрузки страницы -->
    <v-overlay :value="initialLoading" opacity="0.6" z-index="200">
      <div class="d-flex flex-column align-center">
        <v-progress-circular indeterminate size="56" width="5" />
        <div class="mt-4">Загрузка номенклатуры…</div>
      </div>
    </v-overlay>

    <!-- Хлебные крошки -->
    <v-container>
      <v-breadcrumbs
        :items="arrBreadcrumbsToCurrentLeaf"
        large
        class="breadcrumbs-tree"
      >
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="item.href"
            :disabled="item.disabled"
            @click="
              set_open_leaf_tree_in_breadcrumb(item.text);
              scrollToLeaf(item.text);
            "
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-container>

    <!-- Дерево плюс рабочая область   -->
    <div class="nomenclatures-tree">
      <!-- Дерево -->
      <v-card id="tree" :class="['pb-10', { 'tree-hidden': !isTreeVisible }]">
        <v-card-title class="d-flex justify-space-between align-center">
          <span v-if="isTreeVisible">Дерево</span>
          <v-btn icon small @click="isTreeVisible = !isTreeVisible">
            <v-icon>{{
              isTreeVisible ? "mdi-chevron-left" : "mdi-chevron-right"
            }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-treeview
          v-show="isTreeVisible"
          v-if="tree.length"
          v-model="localTree"
          :open.sync="localOpenLeafTree"
          :items="tree"
          item-key="name_leaf"
          ref="treeView"
          open-all
        >
          <template v-slot:prepend="{ open, item }">
            <v-icon>{{ getIconRow(open, item) }}</v-icon>
          </template>
          <template v-slot:label="{ item }">
            <v-btn
              :ref="item.name_leaf"
              class="rollback-vuetify-text-style justify-start"
              :class="{
                selectedLeaf: getStateCheckedLeafByBreadcrumbs(item.name_leaf),
              }"
              block
              text
              @click="setSelectedFamilyAction(item)"
              >{{ item.name_leaf }}</v-btn
            >
            <hr />
          </template>
          <template v-slot:append="{ item }">
            <div class="d-flex align-center" style="grid-column-gap: 5px">
              <IconTooltip
                :text-tooltip="
                  'Добавить подсемейство в ' + `'${item.name_leaf}'`
                "
                :icon-text="'mdi-plus-thick'"
                :class="'ma-2'"
                :color-icon="'primary'"
                :is-disabled="loading"
                @click-icon="
                  set_action_query('add');
                  open_dialog_family(item.id_family);
                "
              />
              <IconTooltip
                :icon-text="'mdi-pencil'"
                :text-tooltip="'Редактировать семейство'"
                :is-disabled="loading"
                @click-icon="setEditFamily(item)"
              />
              <IconTooltip
                :icon-text="'mdi-delete-outline'"
                :text-tooltip="getDeleteMessage(item)"
                :is-disabled="stateExistChildren(item) || loading"
                :color-icon="'red'"
                @click-icon="deleteEntry(item.id_family)"
              />
            </div>
          </template>
        </v-treeview>
      </v-card>
      <!-- Правая часть данных-->
      <v-card class="table_container">
        <v-card-title v-if="!selectedLeafTree.id_family"
          >Не выбрано семейство</v-card-title
        >

        <!-- Таблица характеристик для семейств  -->
        <v-data-table
          v-if="getStateSelectedFamily && getStateExistChildren"
          :key="selectedLeafTree.id_family"
          ref="familyTable"
          :headers="headersFamilyTable"
          :items="listCharacteristicsFilteredByMToM"
          :loading="loading"
          :loading-text="'Загрузка данных'"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-card-title>{{
              'Характеристики семейства - "' + selectedLeafTree.name_leaf
            }}</v-card-title>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <DropDownMenuStyled
                  :is-class="'reverseIconContent'"
                  :is-top="true"
                  :open-on-hover="true"
                >
                  <template #icon>
                    <div class="wrapper_sort">
                      <template>
                        {{
                          item._characteristic_nomenclature.sort
                            ? item._characteristic_nomenclature.sort
                            : "-"
                        }}&nbsp;
                      </template>
                      <div
                        class="d-flex align-center"
                        style="grid-column-gap: 5px"
                      >
                        <v-icon x-small>{{
                          item.id_family === selectedLeafTree.id_family
                            ? "mdi-circle"
                            : "mdi-circle-outline"
                        }}</v-icon>
                        <template>{{ item.name_char }}</template>
                      </div>
                      <template
                        v-if="item._characteristic_nomenclature.postfix"
                      >
                        ({{ item._characteristic_nomenclature.postfix }})
                      </template>
                    </div>
                  </template>
                  <template #content>
                    <section class="d-inline-flex">
                      <IconTooltip
                        :icon-text="'mdi-delete-outline'"
                        :text-tooltip="
                          deniedAccessByDeleteCharacteristic(
                            item.id_characteristic
                          )
                            ? 'Нельзя удалить характеристику, она задана в родителе'
                            : 'Удалить Характеристику'
                        "
                        :is-disabled="
                          deniedAccessByDeleteCharacteristic(
                            item.id_characteristic
                          ) || loading
                        "
                        @click-icon="
                          set_characteristic(item._characteristic_nomenclature);
                          open_dialog_delete_characteristic();
                        "
                      />
                      <IconTooltip
                        :icon-text="'mdi-pencil'"
                        :text-tooltip="'Редактировать Характеристику'"
                        :is-disabled="loading"
                        @click-icon="
                          set_action_query('edit');
                          set_characteristic({
                            id: item._characteristic_nomenclature.id,
                            sort: item._characteristic_nomenclature.sort,
                            name: item._characteristic_nomenclature.name,
                            code: item._characteristic_nomenclature.code,
                            description:
                              item._characteristic_nomenclature.description,
                            postfix: item._characteristic_nomenclature.postfix,
                            id_type_characteristic:
                              item._characteristic_nomenclature
                                .id_type_characteristic,
                            id_dictionary:
                              item._characteristic_nomenclature.id_dictionary,
                            type_characteristic:
                              item._characteristic_nomenclature
                                .type_characteristic,
                            dictionary:
                              item._characteristic_nomenclature.dictionary,
                          });
                          openDialogCharacteristics();
                        "
                      />
                    </section>
                  </template>
                </DropDownMenuStyled>
              </td>

              <td>
                <SelectStyled
                  v-if="
                    item._characteristic_nomenclature.type_characteristic
                      .code === 'vybor-iz-spravocnika'
                  "
                  :items="
                    item._characteristic_nomenclature.dictionary
                      .d_dictionary_attributes
                  "
                  :data="item.value"
                  :item-text="'value'"
                  :item-value="'value'"
                  :placeholder="
                    item._characteristic_nomenclature.dictionary.name
                  "
                  :current-rules="$store.state.requiredFieldRules"
                  :is-hide-details="true"
                  :is-loading="loading"
                  :is-disabled="true"
                  :is-return-object="false"
                  @update-input="
                    item.value = $event;
                    setMToMCharacteristicsNomenclature(item);
                  "
                />
                <InputStyledSimple
                  v-if="
                    ['stroka', 'cislo'].includes(
                      item._characteristic_nomenclature.type_characteristic.code
                    )
                  "
                  :id="item.id_characteristic"
                  :data="item.value"
                  :is-disabled="true"
                  @change-input="
                    item.value = $event;
                    setMToMCharacteristicsNomenclature(item);
                  "
                />
              </td>

              <!--              <td>-->
              <!--                <CheckboxStyled-->
              <!--                  :is-hide-details="true"-->
              <!--                  :state="item.required_fill_in_nomenclature"-->
              <!--                  :is-disabled="true"-->
              <!--                  @change-event="-->
              <!--                    item.required_fill_in_nomenclature = $event;-->
              <!--                    setMToMCharacteristicsNomenclature(item);-->
              <!--                  "-->
              <!--                />-->
              <!--              </td>-->
            </tr>
          </template>
          <template v-slot:foot>
            <tfoot class="footer_static">
              <tr>
                <td colspan="4">
                  <IconTooltip
                    :icon-text="'mdi-plus-thick'"
                    :color-icon="'green'"
                    :class="'justify-start'"
                    :text-tooltip="'Добавить Характеристику'"
                    :is-disabled="loading"
                    @click-icon="
                      set_action_query('add');
                      openDialogCharacteristics();
                    "
                  />
                </td>
              </tr>
            </tfoot>
          </template>
        </v-data-table>

        <!-- Таблица номенклатуры для последних записей семейств -->
        <v-data-table
          v-if="getStateSelectedFamily && !getStateExistChildren"
          :key="selectedLeafTree.id_family"
          ref="nomenclatureTable"
          :headers="listNomenclatureByFamily"
          hide-default-header
          :items="listCharacteristicsFilteredByMToM"
          :loading="loading"
          :loading-text="'Загрузка данных'"
          hide-default-footer
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-card-title>{{ "Номенклатура семейства" }}</v-card-title>
          </template>
          <template v-slot:header="{ props: { headers } }">
            <thead class="v-data-table-header">
              <tr>
                <th class="black--text">{{ selectedLeafTree.name_leaf }}</th>

                <th class="text-center">по умолчанию</th>

                <th v-for="item in headers" :key="item.id" class="text-center">
                  <DropDownMenuStyled
                    :is-class="'reverseIconContent'"
                    :is-offset-y="false"
                    :is-top="true"
                    :open-on-hover="true"
                  >
                    <template #icon>
                      <section>{{ item.name }}</section>
                    </template>
                    <template #content>
                      <section class="d-inline-flex">
                        <IconTooltip
                          :icon-text="'mdi-delete-outline'"
                          :text-tooltip="'Удалить номенклатуру'"
                          :is-disabled="loading"
                          @click-icon="
                            set_nomenclature(item);
                            open_dialog_delete_nomenclature();
                          "
                        />
                        <IconTooltip
                          :icon-text="'mdi-pencil'"
                          :text-tooltip="'Редактировать номенклатуру'"
                          :is-disabled="loading"
                          @click-icon="
                            set_action_query('edit');
                            set_nomenclature(item);
                            open_dialog_nomenclature();
                          "
                        />
                      </section>
                    </template>
                  </DropDownMenuStyled>
                </th>

                <th style="max-width: 40px; background-color: #d3d3d347">
                  <TooltipStyled :title="'Добавить Номенклатуру'">
                    <v-btn
                      text
                      block
                      class="justify-center align-center"
                      @click="
                        set_action_query('add');
                        open_dialog_nomenclature();
                      "
                      :disabled="loading"
                    >
                      <v-icon color="green">mdi-plus-thick</v-icon>
                    </v-btn>
                  </TooltipStyled>
                </th>
              </tr>
            </thead>
          </template>
          <!--
            item.id_characteristic <-> ид_харки
            headers[index].id <-> ид_номенклатуры
          -->
          <template v-slot:item="{ item, index, headers }">
            <tr
              v-if="getStatePublicDisplayCharacteristic(item.id_characteristic)"
              :class="{
                parentPropertyStyle: !item.required_fill_in_nomenclature,
              }"
            >
              <!--Характеристика-->
              <td>
                <DropDownMenuStyled
                  :is-class="'reverseIconContent'"
                  :is-top="true"
                  :open-on-hover="true"
                >
                  <template #icon>
                    <div class="wrapper_sort">
                      <template>
                        {{
                          item._characteristic_nomenclature.sort
                            ? item._characteristic_nomenclature.sort
                            : "-"
                        }}&nbsp;
                      </template>
                      <div
                        class="d-flex align-center"
                        style="grid-column-gap: 5px"
                      >
                        <v-icon x-small>{{
                          item.id_family === selectedLeafTree.id_family
                            ? "mdi-circle"
                            : "mdi-circle-outline"
                        }}</v-icon>
                        <template>{{ item.name_char }}</template>
                      </div>
                      <template
                        v-if="item._characteristic_nomenclature.postfix"
                      >
                        ({{ item._characteristic_nomenclature.postfix }})
                      </template>
                    </div>
                  </template>
                  <template #content>
                    <section class="d-inline-flex">
                      <IconTooltip
                        :icon-text="'mdi-delete-outline'"
                        :text-tooltip="
                          deniedAccessByDeleteCharacteristic(
                            item.id_characteristic
                          )
                            ? 'Нельзя удалить характеристику, она задана в родителе'
                            : 'Удалить Характеристику'
                        "
                        :is-disabled="
                          deniedAccessByDeleteCharacteristic(
                            item.id_characteristic
                          ) || loading
                        "
                        @click-icon="
                          set_characteristic({
                            id: item.id_characteristic,
                            name: item.name_char,
                          });
                          open_dialog_delete_characteristic();
                        "
                      />
                      <IconTooltip
                        :icon-text="'mdi-pencil'"
                        :text-tooltip="'Редактировать Характеристику'"
                        :is-disabled="loading"
                        @click-icon="
                          set_action_query('edit');
                          set_characteristic({
                            id: item._characteristic_nomenclature.id,
                            sort: item._characteristic_nomenclature.sort,
                            name: item._characteristic_nomenclature.name,
                            code: item._characteristic_nomenclature.code,
                            description:
                              item._characteristic_nomenclature.description,
                            postfix: item._characteristic_nomenclature.postfix,
                            id_type_characteristic:
                              item._characteristic_nomenclature
                                .id_type_characteristic,
                            id_dictionary:
                              item._characteristic_nomenclature.id_dictionary,
                            type_characteristic:
                              item._characteristic_nomenclature
                                .type_characteristic,
                            dictionary:
                              item._characteristic_nomenclature.dictionary,
                          });
                          openDialogCharacteristics();
                        "
                      />
                    </section>
                  </template>
                </DropDownMenuStyled>
              </td>

              <!-- По умолчанию (заполняет слева направа ряд номенклатур) -->
              <td>
                <SelectStyled
                  v-if="
                    item._characteristic_nomenclature.type_characteristic
                      .code === 'vybor-iz-spravocnika'
                  "
                  :items="
                    item._characteristic_nomenclature.dictionary
                      .d_dictionary_attributes
                  "
                  :item-text="'value'"
                  :item-value="'value'"
                  :placeholder="
                    item._characteristic_nomenclature.dictionary.name
                  "
                  :current-rules="$store.state.requiredFieldRules"
                  :is-hide-details="true"
                  :is-loading="loading"
                  :is-disabled="loading || !item.required_fill_in_nomenclature"
                  :is-return-object="false"
                  @update-input="
                    setDefaultMToMCharacteristicsNomenclature({
                      id_characteristic: item.id_characteristic,
                      value: $event,
                    })
                  "
                />
                <InputStyledSimple
                  v-if="
                    item._characteristic_nomenclature.type_characteristic
                      .code === 'stroka'
                  "
                  :is-disabled="loading || !item.required_fill_in_nomenclature"
                  @change-input="
                    setDefaultMToMCharacteristicsNomenclature({
                      id_characteristic: item.id_characteristic,
                      value: $event,
                    })
                  "
                />
                <InputStyledSimple
                  v-if="
                    item._characteristic_nomenclature.type_characteristic
                      .code === 'cislo'
                  "
                  :type-data="'number'"
                  :is-disabled="loading || !item.required_fill_in_nomenclature"
                  @change-input="
                    setDefaultMToMCharacteristicsNomenclature({
                      id_characteristic: item.id_characteristic,
                      value: $event,
                    })
                  "
                />
              </td>

              <!-- Инпут value характеристики номенклатуры-->
              <td v-for="(header, key) in headers" :key="key">
                <SelectStyled
                  v-if="
                    item._characteristic_nomenclature.type_characteristic
                      .code === 'vybor-iz-spravocnika'
                  "
                  :items="
                    item._characteristic_nomenclature.dictionary
                      .d_dictionary_attributes
                  "
                  :data="getValueCharacteristicNomenclature(item, header.id)"
                  :item-text="'value'"
                  :item-value="'value'"
                  :placeholder="
                    item._characteristic_nomenclature.dictionary.name
                  "
                  :current-rules="$store.state.requiredFieldRules"
                  :is-hide-details="true"
                  :is-loading="loading"
                  :is-disabled="loading || !item.required_fill_in_nomenclature"
                  :is-return-object="false"
                  @update-input="
                    setMToMCharacteristicsNomenclature({
                      id_characteristic: item.id_characteristic,
                      id_nomenclature: header.id,
                      value: $event,
                      is_nomenclature: 1,
                      required_fill_in_nomenclature: 1,
                    })
                  "
                />
                <InputStyledSimple
                  v-if="
                    item._characteristic_nomenclature.type_characteristic
                      .code === 'stroka'
                  "
                  :class="header.name"
                  :id="header.id"
                  :data="getValueCharacteristicNomenclature(item, header.id)"
                  :is-disabled="loading || !item.required_fill_in_nomenclature"
                  @change-input="
                    setMToMCharacteristicsNomenclature({
                      id_characteristic: item.id_characteristic,
                      id_nomenclature: header.id,
                      value: $event,
                      is_nomenclature: 1,
                      required_fill_in_nomenclature: 1,
                    })
                  "
                />
                <InputStyledSimple
                  v-if="
                    item._characteristic_nomenclature.type_characteristic
                      .code === 'cislo'
                  "
                  :type-data="'number'"
                  :class="header.name"
                  :id="header.id"
                  :data="getValueCharacteristicNomenclature(item, header.id)"
                  :is-disabled="loading || !item.required_fill_in_nomenclature"
                  @change-input="
                    setMToMCharacteristicsNomenclature({
                      id_characteristic: item.id_characteristic,
                      id_nomenclature: header.id,
                      value: $event,
                      is_nomenclature: 1,
                      required_fill_in_nomenclature: 1,
                    })
                  "
                />
              </td>
            </tr>
          </template>
          <template v-slot:foot>
            <tfoot class="footer_static">
              <tr>
                <td :colspan="lengthListNomenclatureByFamily + 2">
                  <TooltipStyled :title="'Добавить Характеристику'">
                    <v-btn
                      text
                      block
                      class="justify-start"
                      @click="
                        set_action_query('add');
                        openDialogCharacteristics();
                      "
                      :disabled="loading"
                    >
                      <v-icon color="green">mdi-plus-thick</v-icon>
                    </v-btn>
                  </TooltipStyled>
                </td>
              </tr>
            </tfoot>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <!-- Диалог для добавления / редактирования семейств -->
    <v-dialog
      :value="dialogFamily"
      @click:outside="
        saveFamilyAction();
        clear_action_query();
      "
      @keydown.esc="
        saveFamilyAction();
        clear_action_query();
      "
    >
      <v-card>
        <v-card-title>
          <section>
            {{ $route.query.action === "edit" ? "Редактирование" : "Создание" }}
            семейства <u>{{ family.name }}</u>
          </section>
        </v-card-title>
        <div class="container">
          <v-col cols="12" sm="12" md="12">
            <ComboboxStyled
              :is-items="listFamiliesBySearch"
              :action="$route.query.action"
              :data="family.name"
              :key="idParentFamily"
              :is-return-object="true"
              :is-item-text="'name'"
              :is-item-value="'name'"
              :is-hide-details="false"
              :is-outlined="false"
              :is-loading="loading"
              :is-error="responseByFamily.isError"
              :is-error-messages="responseByFamily.message"
              @update-search-input="getFamilyBySearch($event)"
              @change-search="localSetSearchFamily"
              @click-clear="clear_family"
            ></ComboboxStyled>
          </v-col>

          <v-col v-if="family.id && !responseByFamily.isError">
            <v-autocomplete
              v-model="selectedMainCharacteristics"
              :disabled="$store.state.loadingRequestGeneral"
              :items="mainCharacteristicsItems"
              :loading="$store.state.loadingRequestGeneral"
              class="mb-10"
              multiple
              chips
              small-chips
              deletable-chips
              hide-details
              item-text="name"
              item-value="id"
              label="Основные параметры разного типа оборудования"
              outlined
              :no-data-text="mainCharacteristicsNoDataText"
              :search-input.sync="mainCharacteristicsSearch"
              :menu-props="{ maxHeight: 320, offsetY: true, bottom: true, auto: false }"
              @change="
                mainCharacteristicsSearch = null;
                onMainCharacteristicsChange($event);
              "
            />
            <InputStyledSimple
              class="mb-5"
              :data="family.seo_title"
              :placeholder="'Seo title'"
              :is-loading="loading"
              @update-input="
                setPropertyFamily({ key: 'seo_title', payload: $event })
              "
            />
            <InputStyledSimple
              class="mb-5"
              :data="family.seo_keywords"
              :placeholder="'Seo keywords'"
              :is-loading="loading"
              @update-input="
                setPropertyFamily({ key: 'seo_keywords', payload: $event })
              "
            />
            <!-- Ссылки семейства -->
            <v-sheet outlined rounded class="pa-3 mb-5">
              <div class="text-caption text--secondary mb-3">Ссылки на документы</div>

              <div
                v-for="link in familyLinks"
                :key="link.id"
                class="d-flex align-start mb-3"
                style="gap: 8px"
              >
                <v-text-field
                  :value="link.name"
                  label="Название"
                  outlined
                  dense
                  hide-details
                  style="max-width: 40%"
                  :disabled="loading"
                  @change="onSavedFamilyLinkChange(link, { name: $event, url: link.url })"
                />
                <v-text-field
                  :value="link.url"
                  label="Ссылка"
                  outlined
                  dense
                  :rules="documentationUrlRules"
                  :disabled="loading"
                  @change="onSavedFamilyLinkChange(link, { name: link.name, url: $event })"
                />
                <v-btn icon :disabled="loading" @click="deleteFamilyLink(link.id)">
                  <v-icon color="red">mdi-delete-outline</v-icon>
                </v-btn>
              </div>

              <div
                v-for="(link, idx) in pendingFamilyLinks"
                :key="'pending-fl-' + idx"
                class="d-flex align-start mb-3"
                style="gap: 8px"
              >
                <v-text-field
                  v-model="link.name"
                  label="Название"
                  outlined
                  dense
                  hide-details
                  style="max-width: 40%"
                  :disabled="loading"
                  @change="onPendingFamilyLinkChange(link, idx)"
                />
                <v-text-field
                  v-model="link.url"
                  label="Ссылка"
                  outlined
                  dense
                  :rules="documentationUrlRules"
                  :disabled="loading"
                  @change="onPendingFamilyLinkChange(link, idx)"
                />
                <v-btn icon @click="pendingFamilyLinks.splice(idx, 1)">
                  <v-icon color="red">mdi-delete-outline</v-icon>
                </v-btn>
              </div>

              <v-btn
                text
                small
                :disabled="loading"
                @click="pendingFamilyLinks.push({ name: '', url: '' })"
              >
                <v-icon color="green" left>mdi-plus-thick</v-icon>
                Добавить ссылку
              </v-btn>
            </v-sheet>
            <v-autocomplete
              :disabled="$store.state.loadingRequestGeneral"
              :items="$store.state.Brands.listBrands"
              :loading="$store.state.loadingRequestGeneral"
              class="mb-5"
              dense
              hide-details
              item-text="name"
              item-value="id"
              :label="
                family?.brand?.name ? family?.brand?.name : 'Выберите бренд'
              "
              outlined
              return-object
              :menu-props="{ maxHeight: 320, offsetY: true, bottom: true, auto: false }"
              @change="
                setPropertyFamily({ key: 'id_brand', payload: $event.id })
              "
            >
            </v-autocomplete>
            <v-autocomplete
              v-model="selectedPublicTags"
              :disabled="$store.state.loadingRequestGeneral"
              :items="$store.state.TagsModule.listTags"
              :loading="$store.state.loadingRequestGeneral"
              class="mb-5"
              multiple
              chips
              small-chips
              deletable-chips
              hide-details
              item-text="name"
              item-value="id"
              label="Выберите тэги для отображаемых характеристик"
              outlined
              :menu-props="{ maxHeight: 320, offsetY: true, bottom: true, auto: false }"
              @change="onPublicTagsChange($event)"
            />
            <DropzoneStyled
              :id-object="family.id"
              :photos-array="family.photos"
            ></DropzoneStyled>
            <VueEditor
              v-model="family.seo_descriptionEditor"
              placeholder="Seo description"
              class="mt-3"
              :editorToolbar="customToolbar"
              ref="characteristicEditor"
              @text-change="localSetDescriptionFamily"
            />
          </v-col>

          <v-btn
            color="primary"
            text
            @click="
              saveFamilyAction();
              clear_action_query();
            "
          >
            Закрыть
          </v-btn>
          <v-btn
            color="primary"
            text
            v-if="$route.query.action === 'add'"
            @click="addChildAction"
            :disabled="!family.id || loading || responseByFamily.isError"
            :loading="loading"
          >
            Добавить в дерево
          </v-btn>
          <v-btn
            color="primary"
            text
            v-if="$route.query.action === 'edit'"
            @click="
              saveFamilyAction();
              clear_action_query();
            "
            :disabled="!family.id || loading || responseByFamily.isError"
            :loading="loading"
          >
            Сохранить
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Диалог добавления / редактирования номенклатуры  -->
    <v-dialog
      :value="dialogNomenclature"
      @click:outside="
        saveNomenclatureAction();
        clear_action_query();
      "
      @keydown.esc="
        saveNomenclatureAction();
        clear_action_query();
      "
    >
      <v-card>
        <v-card-title class="d-block">
          <section>
            {{ $route.query.action === "edit" ? "Редактирование" : "Создание" }}
            номенклатуры <u>{{ nomenclature.name }}</u> в семействе
          </section>
          <section>
            <u>{{ selectedLeafTree.name_leaf }}</u>
          </section>
        </v-card-title>
        <div class="container">
          <v-col>
            <ComboboxStyled
              :action="$route.query.action"
              :is-items="listNomenclaturesBySearch"
              :data="nomenclature.name"
              :key="nomenclature.id"
              :is-return-object="true"
              :is-item-text="'name'"
              :is-item-value="'name'"
              :is-hide-details="false"
              :is-error="responseAddNomenclature.isError"
              :is-error-messages="responseAddNomenclature.message"
              :is-outlined="false"
              :is-loading="loading"
              @update-search-input="getNomenclaturesBySearch($event)"
              @change-search="localSetSearchNomenclature"
              @click-clear="
                clear_nomenclature();
                clear_list_nomenclatures_by_search();
                clear_response_add_nomenclature();
              "
            ></ComboboxStyled>
          </v-col>

          <v-col v-if="nomenclature.id && !responseAddNomenclature.isError">
            <v-expansion-panels
              v-model="panel"
              multiple
              class="mb-5"
              accordion
              focusable
            >
              <v-expansion-panel>
                <v-expansion-panel-header>Основные</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <InputStyledSimple
                    class="mb-5 mt-5"
                    :data="nomenclature.vendor_code"
                    :placeholder="'Артикул'"
                    :is-loading="loading"
                    @update-input="
                      setPropertyNomenclature({
                        key: 'vendor_code',
                        payload: $event,
                      })
                    "
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header
                  >Торговые предложения</v-expansion-panel-header
                >
                <v-expansion-panel-content>
                  <div
                    v-for="link in companyNomenclatureLinks"
                    :key="link.id"
                    class="d-flex align-start mt-5 mb-3"
                    style="gap: 8px"
                  >
                    <v-autocomplete
                      :value="link.id_company"
                      :items="$store.state.Companies.listCompanies"
                      item-text="name"
                      item-value="id"
                      label="Компания"
                      outlined
                      dense
                      hide-details
                      style="max-width: 45%"
                      :disabled="loading"
                      @input="onSavedLinkCompanyChange(link, $event)"
                    />
                    <v-text-field
                      :value="link.url_product"
                      label="Ссылка на товар"
                      outlined
                      dense
                      :rules="urlRules"
                      :disabled="loading"
                      @change="onSavedLinkUrlChange(link, $event)"
                    />
                    <v-btn
                      icon
                      :disabled="loading"
                      @click="deleteCompanyNomenclatureLink(link.id)"
                    >
                      <v-icon color="red">mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>

                  <div
                    v-for="(link, idx) in pendingCompanyLinks"
                    :key="'pending-' + idx"
                    class="d-flex align-start mb-3"
                    style="gap: 8px"
                  >
                    <v-autocomplete
                      v-model="link.id_company"
                      :items="$store.state.Companies.listCompanies"
                      item-text="name"
                      item-value="id"
                      label="Компания"
                      outlined
                      dense
                      hide-details
                      style="max-width: 45%"
                      :disabled="loading"
                      @change="onPendingLinkChange(link, idx)"
                    />
                    <v-text-field
                      v-model="link.url_product"
                      label="Ссылка на товар"
                      outlined
                      dense
                      :rules="urlRules"
                      :disabled="loading"
                      @change="onPendingLinkChange(link, idx)"
                    />
                    <v-btn icon @click="pendingCompanyLinks.splice(idx, 1)">
                      <v-icon color="red">mdi-delete-outline</v-icon>
                    </v-btn>
                  </div>

                  <v-btn
                    text
                    small
                    :disabled="loading"
                    class="mt-1"
                    @click="
                      pendingCompanyLinks.push({
                        id_company: null,
                        url_product: '',
                      })
                    "
                  >
                    <v-icon color="green" left>mdi-plus-thick</v-icon>
                    Добавить магазин
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                <v-expansion-panel-header>Seo</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <InputStyledSimple
                    class="mb-5 mt-5"
                    :data="nomenclature.seo_title"
                    :placeholder="'Seo title'"
                    @update-input="
                      setPropertyNomenclature({
                        key: 'seo_title',
                        payload: $event,
                      })
                    "
                  />
                  <InputStyledSimple
                    class="mb-5"
                    :data="nomenclature.seo_keywords"
                    :placeholder="'Seo keywords'"
                    @update-input="
                      setPropertyNomenclature({
                        key: 'seo_keywords',
                        payload: $event,
                      })
                    "
                  />
                  <VueEditor
                    v-model="nomenclature.seo_descriptionEditor"
                    placeholder="Seo description"
                    class="mt-3"
                    :editorToolbar="customToolbar"
                    ref="characteristicEditor"
                    @text-change="localSetDescriptionNomenclature"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <v-btn
            color="primary"
            text
            @click="
              saveNomenclatureAction();
              clear_action_query();
            "
          >
            Закрыть
          </v-btn>
          <v-btn
            color="primary"
            text
            v-if="$route.query.action === 'add'"
            @click="close_dialog_nomenclature()"
            :disabled="
              !nomenclature.id || loading || responseAddNomenclature.isError
            "
            :loading="loading"
          >
            Добавить
          </v-btn>
          <v-btn
            color="primary"
            text
            v-if="$route.query.action === 'edit'"
            @click="
              saveNomenclatureAction();
              clear_action_query();
            "
            :disabled="
              !nomenclature.id || loading || responseAddNomenclature.isError
            "
            :loading="loading"
          >
            Сохранить
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Диалог удаления номенклатуры  -->
    <v-dialog
      :value="dialogDeleteNomenclature"
      @click:outside="close_dialog_delete_nomenclature()"
      @keydown.esc="close_dialog_delete_nomenclature()"
    >
      <v-card>
        <v-card-title>
          {{
            `Вы точно хотите удалить ${nomenclature.name} из семейства - ${selectedLeafTree.name_leaf}`
          }}
        </v-card-title>
        <v-card-actions>
          <v-btn color="primary" text @click="close_dialog_delete_nomenclature">
            Закрыть
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteNomenclatureByFamily(nomenclature.id)"
            :disabled="!nomenclature.id || loading"
            :loading="loading"
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Диалог добавления / редактирования характеристики  -->
    <v-dialog
      :value="dialogCharacteristics"
      @click:outside="
        close_dialog_characteristics();
        clear_action_query();
      "
      @keydown.esc="
        close_dialog_characteristics();
        clear_action_query();
      "
    >
      <v-card>
        <v-card-title class="d-block">
          <section>
            {{ $route.query.action === "edit" ? "Редактирование" : "Создание" }}
            характеристики <u>{{ characteristic.name }}</u>
          </section>
          <section>
            в семействе <u>{{ selectedLeafTree.name_leaf }}</u>
          </section>
        </v-card-title>
        <v-form
          ref="formCharacteristic"
          class="container form_add_edit_characteristic"
          v-model="valid"
          lazy-validation
        >
          <v-col cols="12" sm="12" md="12">
            <ComboboxStyled
              :is-disabled="$route.query.action === 'edit'"
              :is-items="listCharacteristicsBySearch"
              :data="characteristic.name"
              :key="characteristic.id"
              :is-return-object="true"
              :is-item-text="'name'"
              :is-item-value="'name'"
              :is-error-messages="responseAddCharacteristics.message"
              :is-error="responseAddCharacteristics.isError"
              :is-hide-details="false"
              :is-outlined="false"
              :is-loading="loading"
              @update-search-input="getCharacteristicsBySearch($event)"
              @change-search="localSetSearchCharacteristics"
              @click-clear="
                clear_response_add_characteristic();
                clear_characteristic();
              "
            ></ComboboxStyled>
          </v-col>
          <div v-if="characteristic.id && !responseAddCharacteristics.isError">
            <v-col>
              <SelectStyled
                :data="characteristic.id_type_characteristic"
                :items="listTypeCharacteristics"
                :item-text="'name'"
                :item-value="'id'"
                :placeholder="'Тип параметра'"
                :current-rules="$store.state.requiredFieldRules"
                :is-hide-details="false"
                :is-loading="loading"
                :is-disabled="
                  loading || Boolean(characteristic.id_type_characteristic)
                "
                :is-error="Boolean(characteristic.id_type_characteristic)"
                :is-error-messages="'Уже выбран тип параметра для этой характеристики, изменить нельзя'"
                @update-input="
                  set_type_characteristic($event);
                  updateCharacteristic();
                "
              />
            </v-col>
            <v-col
              cols="6"
              v-if="
                characteristic.type_characteristic.code ===
                'vybor-iz-spravocnika'
              "
            >
              <ComboboxStyled
                :data="characteristic.dictionary.name"
                :is-items="$store.state.DictionariesModule.listEntries"
                :is-item-text="'name'"
                :is-item-value="'id'"
                :is-return-object="true"
                :is-hide-details="false"
                :is-placeholder="'Справочник'"
                :is-loading="loading"
                :is-disabled="loading || Boolean(characteristic.id_dictionary)"
                :is-error="Boolean(characteristic.id_dictionary)"
                :is-error-messages="'Уже выбран справочник для этой характеристики, изменить нельзя'"
                @change-search="
                  set_dictionary_characteristic($event);
                  updateCharacteristic();
                "
                @click-clear="clear_characteristic"
              ></ComboboxStyled>
            </v-col>
            <v-col class="pb-0">
              <InputStyledSimple
                class="sort_input"
                :data="characteristic.sort"
                :placeholder="'Сортировка'"
                :is-loading="loading"
                @update-input="updateSort($event)"
              />
            </v-col>
            <v-col cols="12">
              <VueEditor
                v-model="characteristic.descriptionEditor"
                placeholder="Описание"
                class="mt-5"
                :editorToolbar="customToolbar"
                ref="characteristicEditor"
                @text-change="localSetDescriptionCharacteristic"
              />
            </v-col>
            <v-col cols="12">
              <SelectStyled
                :items="dictionaryUnits.d_dictionary_attributes"
                :item-text="'value'"
                :item-value="'value'"
                :data="characteristic.postfix"
                :placeholder="dictionaryUnits.name"
                :is-loading="loading"
                :is-disabled="loading || Boolean(characteristic.postfix)"
                :is-error="Boolean(characteristic.postfix)"
                :is-return-object="false"
                :is-error-messages="'Уже выбрана единица измерения для этой характеристики, изменить нельзя'"
                @change-input="
                  setPropertyCharacteristic({ key: 'postfix', payload: $event })
                "
              ></SelectStyled>
            </v-col>
          </div>
          <v-btn
            color="primary"
            text
            @click="
              close_dialog_characteristics();
              clear_action_query();
            "
          >
            Закрыть
          </v-btn>
          <v-btn
            color="primary"
            text
            v-if="$route.query.action === 'add'"
            @click="addCharacteristicToForm()"
            :disabled="
              !characteristic.id ||
              loading ||
              responseAddCharacteristics.isError
            "
            :loading="loading"
          >
            Добавить
          </v-btn>
          <v-btn
            color="primary"
            text
            v-if="$route.query.action === 'edit'"
            @click="updateCharacteristicInForm()"
            :disabled="
              !characteristic.id ||
              loading ||
              responseAddCharacteristics.isError
            "
            :loading="loading"
          >
            Сохранить
          </v-btn>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Диалог удаления характеристики  -->
    <v-dialog
      :value="dialogDeleteCharacteristic"
      @click:outside="close_dialog_delete_characteristic()"
      @keydown.esc="close_dialog_delete_characteristic()"
    >
      <v-card>
        <v-card-title class="d-block">
          <section>Вы точно хотите удалить характеристику</section>
          <section>"{{ characteristic.name }}"</section>
          <section>
            {{ `из семейства - ${selectedLeafTree.name_leaf}` }}
          </section>
        </v-card-title>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="close_dialog_delete_characteristic"
          >
            Закрыть
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="deleteCharacteristicByMtoM(characteristic.id)"
            :disabled="!characteristic.id || loading"
            :loading="loading"
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--  Всплывающие уведомления  -->
    <v-snackbar
      :style="{ 'margin-bottom': calcMargin(i) }"
      v-for="(value, i) in popupNotifications"
      :key="i"
      v-model="popupSettings.show"
      :timeout="popupSettings.timeout"
      absolute
      bottom
      dark
      color="#5c80b5"
      right
    >
      <div
        class="d-inline-flex"
        style="width: 100%; justify-content: space-between"
      >
        <section style="align-content: center">{{ value }}</section>
        <v-btn
          color="pink"
          small
          right
          @click="popupSettings.show = false"
          :icon="true"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
    </v-snackbar>

    <!--    <v-overlay
        :absolute="true"
        :value="loading"
    >
      <v-progress-circular
          v-if="loading"
          :indeterminate="true"
          :size="70"
          color="green"
          style="margin: auto"
          width="4"
      ></v-progress-circular>
    </v-overlay>-->
  </div>
</template>

<script>
import IconTooltip from "@/components/common/IconTooltip.vue";
import DropDownMenuStyled from "@/components/common/DropDownMenuStyled.vue";
import TooltipStyled from "@/components/common/TooltipStyled.vue";
import ComboboxStyled from "@/components/common/ComboboxStyled.vue";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import InputStyledSimple from "@/components/common/InputStyledSimple";
import CheckboxStyled from "@/components/common/CheckboxStyled";
import SelectStyled from "@/components/common/SelectStyled";
import DropzoneStyled from "@/components/common/DropzoneStyled.vue";
// import TextAreaStyled from "@/components/common/TextAreaStyled";
import { VueEditor } from "vue2-editor";

export default {
  name: "NomenclaturesTree",
  components: {
    InputStyledSimple,
    TooltipStyled,
    ComboboxStyled,
    DropDownMenuStyled,
    IconTooltip,
    CheckboxStyled,
    SelectStyled,
    DropzoneStyled,
    // TextAreaStyled,
    VueEditor,
  },
  data: () => ({
    sortDebounceTimer: null,
    pendingFamilyLinks: [],
    pendingCompanyLinks: [],
    selectedPublicTags: [],
    initialLoading: true,
    selectedMainCharacteristics: [],
    mainCharacteristicsSearch: null,
    urlRules: [
      (v) =>
        !v ||
        /^https?:\/\/.+/.test(v) ||
        "Ссылка должна начинаться с http:// или https://",
    ],
    documentationUrlRules: [
      (v) =>
        !v ||
        /^https?:\/\/.+/.test(v) ||
        "Ссылка должна начинаться с http:// или https://",
    ],
    isTreeVisible: true,
    icons: {
      openFolder: "mdi-folder-open",
      closedFolder: "mdi-folder",
      circle: "mdi-circle-outline",
    },
    localTree: [],
    headersFamilyTable: [
      {
        text: "Характеристика",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Значение хар-ки", value: "value", align: "center" },
      // {
      //   text: "Возможность изменения в номенклатуре",
      //   value: "nomenclature_filled",
      //   align: "center",
      // },
      // {
      //   text: "Обязательность заполнения *",
      //   value: "required",
      //   align: "center",
      // },
    ],
    panel: [0, 1],

    //Editor
    customToolbar: [
      [{ font: [] }],
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      [{ size: ["small", false, "large", "huge"] }],
      ["bold", "italic", "underline", "strike"],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      [{ header: 1 }, { header: 2 }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      // ["link", "image", "video", "formula"],
      ["link", "formula"],
      [{ direction: "rtl" }],
      ["clean"],
    ],
    valid: true,
  }),
  async mounted() {
    // Сначала только то, без чего страницу не показать: дерево и выбранное семейство.
    // Лоадер висит до этого момента, остальные справочники догружаем параллельно.
    this.initialLoading = true;
    try {
      await this.getTreeOnMount();

      // Открываем семейство из ?family=<id_family> (ссылка на папку), иначе корень
      const leafFromQuery = this.findLeafInTree(
        this.tree,
        Number(this.$route.query.family)
      );
      await this.setSelectedFamilyAction(leafFromQuery || this.tree[0]);
      // ?action=edit вместе с ?family — сразу открываем окно редактирования семейства
      if (leafFromQuery && this.$route.query.action === "edit") {
        this.setEditFamily(leafFromQuery);
      } else if (this.$route.query.action) {
        this.clear_action_query();
      }
      this.$refs.treeView?.updateAll(true);
    } finally {
      this.initialLoading = false;
    }

    await Promise.all([
      this.getDictionaryUnits(),
      this.$store.dispatch("Brands/getListBrands", this.$route.params.id),
      this.$store.dispatch("Companies/getListCompanies"),
      this.$store.dispatch("getListTags"),
    ]);
  },
  watch: {
    // Выбранный лист дерева → ?family=<id_family> (чтобы можно было поделиться ссылкой)
    "selectedLeafTree.id_family"(idFamily) {
      this.setFamilyQuery(idFamily);
    },
    // Ссылка/«назад» изменили ?family — открываем это семейство
    "$route.query.family"(value) {
      const id = Number(value);
      if (!id || id === this.selectedLeafTree.id_family) return;
      const leaf = this.findLeafInTree(this.tree, id);
      if (leaf) this.setSelectedFamilyAction(leaf);
    },
    "family.id": {
      handler() {
        this.pendingFamilyLinks = [];
        this.selectedPublicTags = this.family.ids_tags_public_display || [];
        this.selectedMainCharacteristics =
          this.family.ids_main_characteristics || [];
      },
    },
    dialogFamily(isOpen) {
      if (!isOpen) {
        this.pendingFamilyLinks = [];
      }
    },
    "nomenclature.id": {
      handler(newId) {
        this.$store.commit(
          "NomenclaturesTreeModule/set_company_nomenclature_links",
          newId ? this.nomenclature._company_nomenclatures || [] : []
        );
        this.pendingCompanyLinks = [];
      },
    },
    dialogNomenclature(isOpen) {
      if (!isOpen) {
        this.pendingCompanyLinks = [];
      }
    },
  },
  computed: {
    ...mapState("NomenclaturesTreeModule", [
      "dialogFamily",
      "dialogCharacteristics",
      "dialogNomenclature",
      "family",
      "nomenclature",
      "characteristic",
      "listFamiliesBySearch",
      "listCharacteristicsBySearch",
      "listNomenclaturesBySearch",
      "listNomenclatureByFamily",
      "listCharacteristicsByFamily",
      "loading",
      "tree",
      "idParentFamily",
      "selectedLeafTree",
      "responseAddCharacteristics",
      "responseAddNomenclature",
      "responseByFamily",
      "dialogDeleteNomenclature",
      "listTypeCharacteristics",
      "dialogDeleteCharacteristic",
      "characteristic",
      "dictionaryUnits",
      "arrBreadcrumbsToCurrentLeaf",
      "openBreadcrumbsLeaf",
      "popupNotifications",
      "popupSettings",
      "companyNomenclatureLinks",
      "familyLinks",
    ]),
    ...mapGetters("NomenclaturesTreeModule", [
      "getStateSelectedFamily",
      "getStateExistChildren",
      "getStatePublicDisplayCharacteristic",
      "lengthListNomenclatureByFamily",
      "listCharacteristicsFilteredByMToM",
      "getValueCharacteristicNomenclature",
      "getStateExistAddedCharacteristicInFamily",
      "getStateExistAddedNomenclatureInFamily",
      "deniedAccessByDeleteCharacteristic",
      "getStateCheckedLeafByBreadcrumbs",
    ]),
    ...mapGetters(["stateEditCreate"]),
    mainCharacteristicsNoDataText() {
      return this.mainCharacteristicsItems.length
        ? "Ничего не найдено"
        : "У семейства пока нет своих характеристик — добавьте их в таблице характеристик справа от дерева";
    },
    // Характеристики, занесённые именно в это семейство (без унаследованных от родителей)
    mainCharacteristicsItems() {
      const seen = new Set();
      return this.$store.state.NomenclaturesTreeModule.listMtoMNomenclaturesCharacteristics
        .filter((item) => item.id_family === this.family.id)
        .filter((item) => !seen.has(item.id_characteristic) && seen.add(item.id_characteristic))
        .map((item) => ({
          id: item.id_characteristic,
          name: item._characteristic_nomenclature?.name || item._name_characteristic,
          sort: item._characteristic_nomenclature?.sort,
        }))
        .sort((a, b) => (a.sort ?? Infinity) - (b.sort ?? Infinity));
    },
    localOpenLeafTree: {
      get() {
        return this.openBreadcrumbsLeaf;
      },
      set(newValue) {
        return this.set_open_leaf_tree(newValue);
      },
    },
  },
  methods: {
    ...mapActions("NomenclaturesTreeModule", [
      "getCharacteristicsBySearch",
      "getFamilyBySearch",
      "getNomenclaturesBySearch",
      "getTreeOnMount",
      "addChildAction",
      "setFamilyByName",
      "deleteEntry",
      "setCharacteristicOnFamily",
      "setNomenclaturesByName",
      "setSelectedFamilyAction",
      "setMToMCharacteristicsNomenclature",
      "setDefaultMToMCharacteristicsNomenclature",
      "getNomenclatureByFamily",
      "deleteNomenclatureByFamily",
      "updateCharacteristic",
      "deleteCharacteristicByMtoM",
      "getDictionaryUnits",
      "getMToMNomenclatureCharacteristics",
      "openDialogCharacteristics",
      "setPropertyNomenclature",
      "setPropertyCharacteristic",
      "setPropertyFamily",
      "saveFamilyAction",
      "saveNomenclatureAction",
      "updateNameLeafTree",
      "updateFamily",
      "createCompanyNomenclatureLink",
      "updateCompanyNomenclatureLink",
      "deleteCompanyNomenclatureLink",
      "createFamilyLink",
      "updateFamilyLink",
      "deleteFamilyLink",
    ]),
    ...mapActions("DictionariesModule", ["getListDictionaries"]),
    ...mapMutations("NomenclaturesTreeModule", [
      "close_dialog_characteristics",
      "close_dialog_family",
      "close_dialog_nomenclature",
      "open_dialog_family",
      "open_dialog_nomenclature",
      "clear_list_nomenclatures_by_search",
      "clear_response_add_characteristic",
      "clear_response_add_nomenclature",
      "clear_nomenclature",
      "clear_characteristic",
      "clear_list_characteristics_by_search",
      "clear_family",
      "open_dialog_delete_nomenclature",
      "close_dialog_delete_nomenclature",
      "set_dictionary_characteristic",
      "set_response_add_characteristic",
      "set_response_add_nomenclature",
      "set_type_characteristic",
      "close_dialog_delete_characteristic",
      "set_characteristic",
      "open_dialog_delete_characteristic",
      "set_nomenclature",
      "set_family",
      "clear_list_families_by_search",
      "set_open_leaf_tree",
      "set_open_leaf_tree_in_breadcrumb",
      "set_property_family",
      "add_popup_notification",
    ]),
    onPublicTagsChange(tagIds) {
      this.updateIdsTagsPublicDisplay(tagIds);
    },
    onMainCharacteristicsChange(ids) {
      this.updateIdsMainCharacteristics(ids);
    },
    async onSavedFamilyLinkChange(link, { name, url }) {
      await this.updateFamilyLink({ id: link.id, name, url });
    },
    async onPendingFamilyLinkChange(link, idx) {
      if (!link.name || !link.url) return;
      const response = await this.createFamilyLink({ name: link.name, url: link.url });
      if (!response.isError) {
        this.pendingFamilyLinks.splice(idx, 1);
      }
    },
    async onSavedLinkCompanyChange(link, newCompanyId) {
      if (!newCompanyId) return;
      await this.updateCompanyNomenclatureLink({
        id: link.id,
        id_company: newCompanyId,
        url_product: link.url_product,
      });
    },
    async onSavedLinkUrlChange(link, newUrl) {
      if (!link.id_company) return;
      await this.updateCompanyNomenclatureLink({
        id: link.id,
        id_company: link.id_company,
        url_product: newUrl,
      });
    },
    async onPendingLinkChange(link, idx) {
      if (!link.id_company || !link.url_product) return;
      const response = await this.createCompanyNomenclatureLink({
        id_company: link.id_company,
        url_product: link.url_product,
      });
      if (!response.isError) {
        this.pendingCompanyLinks.splice(idx, 1);
      }
    },
    getIconRow(open, item) {
      if (!item.children) return this.icons.circle;

      return open ? "mdi-folder-open" : "mdi-folder";
    },
    async localSetSearchFamily(obj) {
      if (!obj) return false;

      const nameFamily = obj.name ? obj.name : obj;
      if (this.$route.query.action === "add") {
        await this.setFamilyByName(nameFamily);
      }
      if (this.$route.query.action === "edit") {
        this.set_property_family({ key: "name", payload: nameFamily });
        const response = await this.updateFamily();
        if (!response.isError) {
          await this.updateNameLeafTree();
        }
      }
    },
    async localSetSearchCharacteristics(obj) {
      if (!obj) return false;

      const nameFamily = obj.name ? obj.name : obj;
      const response = await this.setCharacteristicOnFamily(nameFamily);
      if (response.isError) return false;

      this.clear_list_characteristics_by_search();

      await this.getListDictionaries({ query: { flag_nomenclature: true } });
    },
    async localSetSearchNomenclature(obj) {
      if (!obj) return false;

      const name = obj.name ? obj.name : obj;

      if (this.$route.query.action === "add") {
        const entry = await this.setNomenclaturesByName(name);
        const existEntry = this.getStateExistAddedNomenclatureInFamily(
          entry.id
        );

        this.clear_response_add_nomenclature();
        if (existEntry) {
          const message =
            entry.name +
            " такое наименование уже существует в текущем семействе, создайте другое";
          this.set_response_add_nomenclature({
            message: message,
            codeResponse: 409,
          });
          this.add_popup_notification(message);
          return false;
        }
        await this.getNomenclatureByFamily(this.selectedLeafTree.id_family);
      }
      if (this.$route.query.action === "edit") {
        this.setPropertyNomenclature({ key: "name", payload: name });
      }
    },
    stateExistChildren(item) {
      if (!item.children) return false;

      if (!item.children.length) return false;

      return true;
    },
    getDeleteMessage(item) {
      if (item.children) return "Нельзя удалить семейство с детьми";

      return "Удалить семейство" + `'${item.name_leaf}'`;
    },
    async localSetDescriptionCharacteristic() {
      if (
        this.characteristic.descriptionEditor ===
        this.characteristic.description
      )
        return false;

      this.setPropertyCharacteristic({
        key: "description",
        payload: this.characteristic.descriptionEditor,
      });
    },
    async localSetDescriptionNomenclature() {
      if (
        this.nomenclature.seo_descriptionEditor ===
        this.nomenclature.seo_description
      )
        return false;

      this.setPropertyNomenclature({
        key: "seo_description",
        payload: this.nomenclature.seo_descriptionEditor,
      });
    },
    async localSetDescriptionFamily() {
      if (this.family.seo_descriptionEditor === this.family.seo_description)
        return false;

      this.setPropertyFamily({
        key: "seo_description",
        payload: this.family.seo_descriptionEditor,
      });
    },

    // Работаем с кверями
    // action (диалоги) меняем, не затирая family (открытая папка)
    clear_action_query() {
      const { action, ...rest } = this.$route.query;
      this.$router.replace({ query: rest }).catch(() => {});
    },
    set_action_query(action) {
      this.$router
        .replace({ query: { ...this.$route.query, action } })
        .catch(() => {});
    },
    setFamilyQuery(idFamily) {
      if (!idFamily || Number(this.$route.query.family) === idFamily) return;
      this.$router
        .replace({ query: { ...this.$route.query, family: idFamily } })
        .catch(() => {});
    },
    findLeafInTree(leafs, idFamily) {
      if (!idFamily || !Array.isArray(leafs)) return null;
      for (const leaf of leafs) {
        if (leaf.id_family === idFamily) return leaf;
        const found = this.findLeafInTree(leaf.children, idFamily);
        if (found) return found;
      }
      return null;
    },

    //Валидация
    async addCharacteristicToForm() {
      const stateValidation = this.$refs.formCharacteristic.validate();
      if (!stateValidation) return false;

      const response = await this.setMToMCharacteristicsNomenclature({
        id_characteristic: this.characteristic.id,
        required_fill_in_nomenclature: 1,
      });
      if (response.codeResponse >= 400) return false;

      this.close_dialog_characteristics();
    },
    updateCharacteristicInForm() {
      const stateValidation = this.$refs.formCharacteristic.validate();
      if (!stateValidation) return false;

      this.getMToMNomenclatureCharacteristics(this.selectedLeafTree.id_family);
      this.close_dialog_characteristics();
      this.clear_action_query();
    },

    scrollToLeaf(refVar) {
      this.$nextTick(() => {
        this.$refs[refVar].$el.scrollIntoView({ behavior: "smooth" });
      });
    },
    calcMargin(i) {
      return i * 60 + "px";
    },

    updateSort(value) {
      this.$store.commit("NomenclaturesTreeModule/set_property_characteristic", {
        key: "sort",
        payload: value,
      });
      clearTimeout(this.sortDebounceTimer);
      this.sortDebounceTimer = setTimeout(async () => {
        await this.setPropertyCharacteristic({ key: "sort", payload: value });
        await this.getMToMNomenclatureCharacteristics(
          this.selectedLeafTree.id_family
        );
      }, 1500);
    },

    setEditFamily(item) {
      this.set_action_query("edit");
      this.set_family(item._family);
      this.open_dialog_family(item.id_family);
      this.setSelectedFamilyAction(item);
    },
    async updateIdsTagsPublicDisplay(tagIds) {
      await this.setPropertyFamily({
        key: "ids_tags_public_display",
        payload: tagIds,
      });
      this.selectedLeafTree._family.ids_tags_public_display = tagIds;
    },
    async updateIdsMainCharacteristics(ids) {
      await this.setPropertyFamily({
        key: "ids_main_characteristics",
        payload: ids,
      });
      this.selectedLeafTree._family.ids_main_characteristics = ids;
    },
  },
  beforeRouteLeave: function (to, from, next) {
    this.close_dialog_delete_characteristic();
    this.close_dialog_characteristics();
    this.close_dialog_delete_nomenclature();
    this.close_dialog_nomenclature();
    this.close_dialog_family();
    this.clear_response_add_characteristic();
    this.clear_list_nomenclatures_by_search();
    this.clear_characteristic();
    this.clear_list_characteristics_by_search();
    next();
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs-tree {
  position: sticky;
  top: 50px;
  z-index: 9;
  background: white;
  padding-left: 10px;
  //box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
}
.nomenclatures-tree {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 10px;
  padding: 15px;
  #tree {
    &.tree-hidden {
      min-width: unset;
      width: fit-content;
    }
  }
  .selectedLeaf {
    background: rgba(25, 118, 210, 0.1) !important;
    //background: rgb(231, 237, 249) !important;
  }

  .table_container {
    .v-data-table {
      tbody {
        tr {
          td {
            padding-top: 10px;
            padding-bottom: 10px;
          }
        }
      }
    }
  }

  .parentPropertyStyle {
    background: #d3d3d37d;
  }

  .footer_static {
    position: sticky;
    background-color: #d3d3d347;
    width: 100%;
  }
}
</style>
<style lang="scss">
.nomenclatures-tree {
  .table_container {
    overflow-x: scroll;
    .v-data-table__wrapper {
      overflow-x: unset;
      overflow-y: unset;
      width: fit-content;

      thead {
        display: table;
        width: 100%;
        background: aliceblue;
      }
      tbody {
        overflow-y: scroll;
        max-height: 650px;
        display: block;
      }
      th,
      td {
        max-width: 200px;
        min-width: 200px;
      }

      .v-data-table-header {
        // не работает с overflow любым у родителя
        //position: sticky;
        //top: 0;
        //z-index: 11;
      }
      .icon_slot {
        width: auto;
        min-width: 150px;
        .wrapper_sort {
          display: grid;
          grid-template-columns: 15% 1fr auto;
          align-items: center;
        }
      }
    }
  }
}

.form_add_edit_characteristic {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }
}
</style>
